<formly-form [model]="value"
             (modelChange)="changeBridge($event)"
             [fields]="fields"></formly-form>
